import React from 'react'
import CarFuturSlide from '../element/CarFuturSlide'


const Bestcar = ({ setOpen }) => {
    return (
        <>
            <div className="row features-box">
                <CarFuturSlide />
                <div className="col-12 col-lg-6 align-self-center m-b30">
                    <div className="content-box right" style={{ padding: '0 8px' }}>
                        <div className="section-head">
                            <h6 className="sub-title style-1">Les meilleures voitures d'occasion</h6>
                            <h2 className="title" style={{ fontSize: 'clamp(1.3rem, 5vw, 2.2rem)', lineHeight: '1.25' }}>Nous vous proposons les meilleures voitures au meilleur prix</h2>
                        </div>
                        <p className="m-b40">Depuis 1993, Automobile AZ sélectionne avec soin les véhicules d'occasion les plus fiables et les plus attractifs. Notre expertise de plus de 30 ans nous permet de vous offrir une gamme variée, des citadines aux berlines de luxe, livrées clé en main en Belgique.</p>

                    </div>
                </div>
            </div>



        </>
    )
}

export default Bestcar